const STORAGE_KEY = 'pixie_event_discount'
const TTL_MS = 7 * 24 * 60 * 60 * 1000 // 7 days

type StoredDiscount = {
  code: string
  slug: string
  expiresAt: number
}

type EventDiscount = {
  code: string
  slug: string
}

export const setEventDiscount = (code: string, slug: string) => {
  if (typeof window === 'undefined') return

  const data: StoredDiscount = {
    code,
    slug,
    expiresAt: Date.now() + TTL_MS,
  }

  localStorage.setItem(STORAGE_KEY, JSON.stringify(data))
}

export const getEventDiscount = (): EventDiscount | null => {
  if (typeof window === 'undefined') return null

  try {
    const raw = localStorage.getItem(STORAGE_KEY)

    if (!raw) return null

    const data: StoredDiscount = JSON.parse(raw)

    if (Date.now() > data.expiresAt) {
      localStorage.removeItem(STORAGE_KEY)

      return null
    }

    return { code: data.code, slug: data.slug }
  } catch {
    return null
  }
}

export const clearEventDiscount = () => {
  if (typeof window === 'undefined') return
  localStorage.removeItem(STORAGE_KEY)
}
